var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareCopyLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/\u590D\u5236\u94FE\u63A5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8BE6\\u60C5-\\u5206\\u4EAB",
    transform: "translate(-48.000000, -565.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(0.000000, 474.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(34.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2857143,1.14285714 L10.2857143,10.2857143 L1.14285714,10.2857143 L1.14285714,1.14285714 L10.2857143,1.14285714 Z M1.14285714,0 C0.511674572,0 0,0.511674572 0,1.14285714 L0,10.2857143 C0,10.9168969 0.511674572,11.4285714 1.14285714,11.4285714 L10.2857143,11.4285714 C10.9168969,11.4285714 11.4285714,10.9168969 11.4285714,10.2857143 L11.4285714,1.14285714 C11.4285714,0.511674572 10.9168969,0 10.2857143,0 L1.14285714,0 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57142857,11.4285714 L4.57142857,14.8571429 C4.57142857,15.4883254 5.08310314,16 5.71428571,16 L14.8571429,16 C15.4883254,16 16,15.4883254 16,14.8571429 L16,5.71428571 C16,5.08310314 15.4883254,4.57142857 14.8571429,4.57142857 L11.4285714,4.57142857 L11.4285714,5.71428571 L14.8571429,5.71428571 L14.8571429,14.8571429 L5.71428571,14.8571429 L5.71428571,11.4285714 L4.57142857,11.4285714 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCopyLinkIcon);
export default __webpack_public_path__ + "static/media/share-copy-link-icon.c480ef3ed7128a6a1981bb3264e7854b.svg";
export { ForwardRef as ReactComponent };